import {
    checkHttpStatus,
    extractAuthenticationHeader,
    parseBLOB,
    parseJSON,
    transformResponse,
} from './utils';
import { push } from 'connected-react-router';

import { store } from '../../store';
import { injectReducer } from '../../store/reducers';
import { fromJS } from 'immutable';
import api from './library';
import moment from 'moment';

import receiptsReducer from '../../routes/Receipts/reducers';
import branchesReducer from '../../routes/Branches/reducers';
import subscriptionsReducer from '../../routes/Subscriptions/reducers';
import settingsReducer from '../../routes/Settings/reducers';

import reduceReducers from 'reduce-reducers';
import config from './config';
import ActionCable from 'actioncable';

import * as globalActions from '../../global/actions';

import { normalize, schema } from 'normalizr';

let cable = ActionCable.createConsumer(config.websockets);

const subscription = new schema.Entity('subscriptions');
const branch = new schema.Entity('branches');

const receiptsSerializer = json => {
    try {
        return { items: json.receipts };
    } catch (error) {
        throw new Error('serialization failed!');
    }
};

const parseDate = date => {
    if (date !== null && date !== undefined && date !== '') {
        return moment(date).toDate();
    } else {
        return '';
    }
};

const subscriptionsSerializer = json => {
    try {
        return json.subscriptions;
    } catch (error) {
        throw new Error('serialization failed');
    }
};

const subscriptionSerializer = json => {
    try {
        const id = json.subscription.id;
        const payload = {};
        payload[id] = json.subscription;
        return payload;
    } catch (error) {
        throw new Error('serialization failed');
    }
};

const userSerializer = json => {
    try {
        return { items: json.users };
    } catch (error) {
        throw new Error('serialization failed!');
    }
};

const connectConfigToStore = store => () => {
    const state = store.getState();
    const auth = state.auth || {};
    const token = localStorage.getItem('scantouch_token');
    let headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    let endpointPrefix = null;

    if (token !== undefined && token !== null) {
        let jsonToken = JSON.parse(token);

        if (jsonToken !== null) {
            endpointPrefix = jsonToken.tenant_name;
            headers = Object.assign(
                {
                    'access-token': jsonToken.access_token,
                    uid: jsonToken.uid,
                    client: jsonToken.client,
                    expiry: jsonToken.expiry,
                    'token-type': 'Bearer',
                },
                headers
            );
        }
    }

    return {
        root: config.apiRoot,
        headers: headers,
        endpointPrefix: endpointPrefix,
        credentials: 'include',
        method: 'GET',
    };
};

const endPoints = api(store, state => ({
    conf: connectConfigToStore(store),
    endPoints: {
        settings: {
            initialState: {},
            get: {
                request: {
                    endpoint: '/settings/1',
                    method: 'GET',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(globalActions.showMessage('Einstellungen geladen'));
                    },
                    failure: (dispatch, error, args) => {
                        dispatch(
                            globalActions.showMessage('Einstellungen konnten nicht geladen werden')
                        );
                    },
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        return state.merge(payload.setting).merge({ isFetching: false });
                    },
                },
            },
            update: {
                request: {
                    endpoint: '/settings',
                    method: 'PUT',
                    body: ['setting'],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(
                            globalActions.showMessage('Einstellungen erfolgreich gespeichert')
                        );
                    },
                    failure: (dispatch, error, args) => {
                        dispatch(
                            globalActions.showMessage(
                                'Einstellungen konnten nicht gespeichert werden'
                            )
                        );
                    },
                },
            },
            getReceiptSyncs: {
                request: {
                    endpoint: '/receipt_syncs/',
                    method: 'GET',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(
                            globalActions.showMessage(
                                'Einstellungen für Beleg-Synchronisation geladen'
                            )
                        );
                    },
                    failure: (dispatch, error, args) => {
                        dispatch(
                            globalActions.showMessage(
                                'Einstellungen für Beleg-Synchronisation konnten nicht geladen werden'
                            )
                        );
                    },
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        return state.merge(payload).merge({ isFetching: false });
                        // return state.merge({isFetching: false})
                    },
                },
            },
            updateStaticApiToken: {
                request: {
                    endpoint: '/users/static_api_token/reset',
                    method: 'POST'
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(globalActions.showMessage('Token aktualisiert'));
                    },
                    failure: (dispatch, errors, args) => {
                        dispatch(
                            globalActions.showMessage('Tokenaktualisierung fehlgeschlagen.')
                        );
                    },
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        return state.merge({static_api_token: payload['static_api_token']});
                    },
                },
            },
        },
        account: {
            initialState: {
                isFetching: false,
            },
            get: {
                request: {
                    endpoint: '/account',
                    method: 'GET',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(globalActions.showMessage('Konto geladen'));
                    },
                    failure: (dispatch, error, args) => {
                        dispatch(globalActions.showMessage('Keine Kontodaten vorhanden'));
                    },
                },
            },
            update: {
                request: {
                    endpoint: '/account',
                    method: 'PUT',
                    body: ['account'],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(globalActions.showMessage('Einstellungen aktualisiert'));
                    },
                    failure: (dispatch, error, args) => {
                        console.log(error);
                        dispatch(
                            globalActions.showMessage('Einstellungen aktualisieren fehlgeschlagen')
                        );
                    },
                },
            },
        },
        receipts: {
            initialState: {
                selectedReceipts: [],
                types: [
                    'all',
                    'rearrangement',
                    'stocktaking',
                    'stock_flow_adjustment',
                    'goods_receipt',
                    'price_change',
                    'retour',
                ],
                filterByType: 'stocktaking',
                from: moment().subtract(3, 'days'),
                to: moment(),
                isFetching: false,
                didInvalidate: false,
                items: [],
            },
            fetchReceipt: {
                request: {
                    endpoint: '/receipts/:id',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {},
                    failure: (dispatch, error, args) => {},
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        let details = {};
                        details[payload.receipt.type + '_' + payload.receipt.id] = payload;
                        return state.merge({ isFetching: false, details });
                    },
                },
            },
            fetchReceipts: {
                request: {
                    endpoint: '/receipts?from=:from&to=:to',
                    // TODO:
                },
                response: {
                    transform: [checkHttpStatus, parseJSON, receiptsSerializer],
                    success: (dispatch, response, args) => {},
                    failure: (dispatch, error, args) => {},
                },
            },
            exportReceipts: {
                request: {
                    endpoint: '/receipts/export',
                    method: 'POST',
                    body: ['receipts', 'selectedBranch', 'selectedUser', 'from', 'to'],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        window.downloadFile(config.root + response['fileName']);
                    },
                    failure: (dispatch, error, args) => {},
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        return state.merge({ isFetching: false });
                    },
                },
            },
            exportReceiptsToAdverics: {
                request: {
                    endpoint: '/receipts/export-to-advarics',
                    method: 'POST',
                    body: ['receipts', 'selectedBranch', 'selectedUser', 'from', 'to'],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        if(response['notice'] != undefined){
                            dispatch(globalActions.showMessage(response['notice']));
                        }

                        if(response['error'] != undefined){
                            dispatch(globalActions.showMessage(response['error']));
                        }
                    },
                    failure: (dispatch, error, args) => {
                        dispatch(globalActions.showMessage('Ungültige Advarics-Anmeldeinformationen'));
                    },
                },
            },
            printSelectedReceipts: {
                request: {
                    endpoint: '/print',
                    method: 'POST',
                    body: [
                        'receipts',
                        'selectedBranch',
                        'selectedUser',
                        'from',
                        'to',
                        'include_positions',
                    ],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        window.downloadFile(config.root + response['fileName']);
                    },
                    failure: (dispatch, error, args) => {},
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        return state.merge({ isFetching: false });
                    },
                },
            },
            printReceipts: {
                request: {
                    endpoint: '/receipts/print',
                    method: 'POST',
                    body: ['receipts', 'selectedBranch', 'selectedUser', 'from', 'to'],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        window.downloadFile(config.root + response['fileName']);
                    },
                    failure: (dispatch, error, args) => {},
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        return state.merge({ isFetching: false });
                    },
                },
            },
            downloadReceipt: {
                request: {
                    endpoint: '/receipts_pdf/:id',
                    method: 'GET',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        window.downloadFile(config.root + response['fileName']);
                    },
                    failure: (dispatch, error, args) => {},
                },
            },
            deleteReceipts: {
                request: {
                    endpoint: '/receipts/delete',
                    method: 'POST',
                    body: ['receipts', 'selectedBranch', 'selectedUser', 'from', 'to'],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(push('/receipts'));
                    },
                    failure: (dispatch, error, args) => {},
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        const receipts = fromJS(payload.receipts).map(item => {
                            return '' + item.get('type') + '_' + item.get('id');
                        });
                        let items = state.get('items').filter(item => {
                            return !receipts.includes(item.get('id'));
                        });
                        return state.merge({ items: items }).merge({ isFetching: false });
                    },
                },
            },
            getReceipt: {
                request: {
                    endpoint: '/v1/receipts/:id',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        console.log(response);
                    },
                    failure: (dispatch, error, args) => {
                        console.log(error);
                    },
                },
            },
        },
        user: {
            initialState: {
                isLoading: false,
            },
            updateUser: {
                request: {
                    endpoint: '/users/:id',
                    method: 'PUT',
                    body: ['user'],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(globalActions.showMessage('Einstellungen aktualisiert'));
                    },
                    failure: (dispatch, error, args) => {
                        dispatch(
                            globalActions.showMessage('Einstellungen aktualisieren fehlgeschlagen')
                        );
                    },
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        return state.merge(fromJS(payload.user));
                    },
                },
            },
            updateSettings: {
                request: {
                    endpoint: '/settings/1',
                    method: 'PUT',
                    body: ['setting'],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(globalActions.showMessage('Einstellungen aktualisiert'));
                    },
                    failure: (dispatch, errors, args) => {
                        var adverics_api_message = "";

                        if (args.setting.data_format === 'advarics' && (args.setting.advarics_api_url != "" || args.setting.advarics_auth_key != "")) {
                            adverics_api_message = " / Ungültige API-Anmeldeinformationen";
                        }
                        dispatch(
                            globalActions.showMessage('Einstellungen aktualisieren fehlgeschlagen' + adverics_api_message)
                        );
                    },
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        return state.mergeIn(['settings'], fromJS(payload.setting));
                    },
                },
            },
            currentUser: {
                request: {
                    endpoint: '/current_user',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        // Maybe we have to pass the state here in
                        // order for the websocket to access dates
                        connectToWebsocket(response.user.tenant_name);
                    },
                    failure: (dispatch, error, args) => {},
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        return state.merge(fromJS(payload.user));
                    },
                },
            },
        },
        device_guidelines: {
            initialState: {
                settings: [],
            },
            update: {
                request: {
                    endpoint: '/settings/:id',
                    method: 'PUT',
                    body: ['setting'],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(globalActions.showMessage('Gerätevorgaben gespeichert'));
                    },
                    failure: (dispatch, errors, args) => {
                        dispatch(
                            globalActions.showMessage(
                                'Gerätevorgaben konnten nicht gespeichert werden.'
                            )
                        );
                    },
                },
            },
            get: {
                request: {
                    endpoint: '/settings',
                    method: 'GET',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(globalActions.showMessage('Gerätevorgaben geladen'));
                    },
                    failure: (dispatch, errors, args) => {
                        dispatch(
                            globalActions.showMessage(
                                'Gerätevorgaben konnten nicht geladen werden.'
                            )
                        );
                    },
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        return state
                            .merge({
                                settings: fromJS(payload.settings[0]),
                            })
                            .merge({ isFetching: false })
                            .updateIn(['settings'], fromJS({}), settings =>
                                settings.merge({
                                    settings_pin_confirmation: settings.get('article_pin'),
                                    article_pin_confirmation: settings.get('article_pin'),
                                    report_pin_confirmation: settings.get('report_pin'),
                                })
                            )
                            .updateIn(
                                ['settings', 'stocktaking_setting'],
                                fromJS({}),
                                stocktaking_setting =>
                                    stocktaking_setting.merge({
                                        default_admission_day: parseDate(
                                            stocktaking_setting.get('default_admission_day')
                                        ),
                                    })
                            )
                            .updateIn(
                                ['settings', 'stocktaking_setting', 'barcode_type_settings'],
                                fromJS([]),
                                barcode_type_settings =>
                                    barcode_type_settings.map(setting =>
                                        setting.merge({
                                            enabled: setting.get('enabled') === true ? 1 : 0,
                                        })
                                    )
                            );
                    },
                },
            },
        },
        invoices: {
            initialState: {
                items: [],
            },
            generateInvoicePDF: {
                request: {
                    endpoint: '/invoices/:id/customer_token?contractId=:contractId',
                    method: 'GET',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        const token = response.customerToken.Token;
                        const portal = new window.BillwerkJS.Portal(token);
                        const invoiceURL = portal.invoicePdfDownloadUrl(args.id);
                        window.downloadFile(invoiceURL);
                    },
                    failure: (dispatch, errors, args) => {
                        dispatch(
                            globalActions.showMessage('Rechnungen konnten nicht geladen werden')
                        );
                    },
                },
            },
            fetchInvoices: {
                request: {
                    endpoint: '/invoices',
                    method: 'GET',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {},
                    failure: (dispatch, errors, args) => {
                        dispatch(
                            globalActions.showMessage('Rechnungen konnten nicht geladen werden')
                        );
                    },
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        console.log(payload);
                        return state
                            .mergeIn(['items'], fromJS(payload.invoices))
                            .merge({ isFetching: false });
                    },
                },
            },
        },
        coupons: {
            initialState: {
                isFetching: false,
            },
            submitCoupon: {
                request: {
                    endpoint: '/subscriptions/check_coupon',
                    method: 'POST',
                    body: ['code', 'planVariantId', 'planId'],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(globalActions.showMessage('Coupon erfolgreich eingegeben'));
                    },
                    failure: (dispatch, errors, args) => {
                        dispatch(
                            globalActions.showMessage('Der eingegebene Coupon ist nicht gültig')
                        );
                    },
                },
                reducer: {
                    FAILED: (state, payload) => {
                        console.log(payload);
                        return state.mergeIn([payload['errors']['planVariantId']], {
                            code: null,
                            discount: null,
                            isFetching: false,
                        });
                    },
                    SUCCESS: (state, payload) => {
                        console.log(payload);
                        return state.mergeIn([payload.planVariantId], {
                            code: payload.code,
                            discount: payload.discount,
                            isFetching: false,
                        });
                    },
                },
            },
        },
        subscriptions: {
            initialState: {
                isLoading: false,
                items: {},
            },
            cancelSubscription: {
                request: {
                    endpoint: '/subscriptions/:id/cancel',
                    method: 'POST',
                    body: [''],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(globalActions.showMessage('Lizenz erfolgreich gekündigt'));
                    },
                    failure: (dispatch, errors, args) => {
                        dispatch(
                            globalActions.showMessage('Lizenzen konnten nicht gekündigt werden')
                        );
                    },
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        return state
                            .updateIn(['items'], fromJS([]), items =>
                                items.filter((value, key) => {
                                    return value.get('id') !== payload.id;
                                })
                            )
                            .merge({ isFetching: false });
                    },
                },
            },
            addSubscription: {
                request: {
                    endpoint: '/subscriptions',
                    method: 'POST',
                    body: ['subscription', 'code'],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(globalActions.showMessage('Neue Lizenzen erfolgreich erworben'));
                        dispatch(push('/subscriptions/success'));
                    },
                    failure: (dispatch, errors, args) => {
                        dispatch(
                            globalActions.showMessage('Lizenzen konnten nicht erworben werden')
                        );
                    },
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        return state
                            .mergeIn(['newSubscription', 'contract'], payload)
                            .merge({ isFetching: false });
                    },
                },
            },
            fetchSubscriptions: {
                request: {
                    endpoint: '/subscriptions',
                    method: 'GET',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {},
                    failure: (dispatch, error, args) => {},
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        const response = normalize(payload.subscriptions || [], [subscription]);
                        return state
                            .mergeIn(['items'], response.entities.subscriptions)
                            .merge({ isFetching: false });
                    },
                },
            },
            uncoupleSubscriptions: {
                request: {
                    endpoint: '/subscriptions/uncouple',
                    method: 'POST',
                    body: ['ids'],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(
                            globalActions.showMessage(
                                'Gerät(e) erfolgreich von Lizenz(en) entkoppelt'
                            )
                        );
                    },
                    failure: (dispatch, error, args) => {
                        dispatch(
                            globalActions.showMessage(
                                'Gerät(e) konnten nicht von Lizenz(en) entkoppelt werden'
                            )
                        );
                    },
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        const response = normalize(payload.subscriptions || [], [subscription]);
                        return state
                            .mergeIn(['items'], response.entities.subscriptions)
                            .merge({ isFetching: false });
                    },
                },
            },
        },
        registration: {
            initialState: {
                isLoading: false,
            },
            accept_invitation: {
                request: {
                    endpoint: '/users/invitation',
                    body: ['invitation_token', 'password', 'password_confirmation'],
                    method: 'PUT',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(
                            globalActions.showMessage(
                                'Ihr Konto ist nun eingerichtet. Bitte melden Sie sich an.'
                            )
                        );
                        dispatch(push('/login'));
                    },
                    failure: (dispatch, error, args) => {},
                },
            },
            register: {
                request: {
                    endpoint: '/users',
                    body: ['user'],
                    method: 'POST',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(
                            globalActions.showMessage(
                                'Registrierung erfolgreich. Eine Bestätigungsemail kommt in Kürze.'
                            )
                        );
                        dispatch(push('/login'));
                    },
                    failure: (dispatch, error, args) => {
                        dispatch(globalActions.showMessage('Registrierung fehlgeschlagen.'));
                    },
                },
            },
        },
        plans: {
            initialState: {
                items: {},
                errors: {},
                isUploading: false,
            },
            fetch: {
                request: {
                    endpoint: '/plans',
                    method: 'GET',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {},
                    failure: (dispatch, error, args) => {},
                },
            },
        },
        branches: {
            initialState: {
                items: {},
                errors: {},
                isUploading: false,
            },
            deleteBranch: {
                request: {
                    endpoint: '/branches/:branch_id',
                    method: 'DELETE',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(push('/branches'));
                        dispatch(globalActions.showMessage('Filiale wurde gelöscht'));
                    },
                    failure: (dispatch, error, args) => {
                        dispatch(
                            globalActions.showMessage('Filiale konnte nicht gelöscht werden.')
                        );
                    },
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        return state.deleteIn(['items', '' + payload.branch.id]).merge({
                            isFetching: payload.isFetching,
                            finishedFetching: payload.finishedFetching,
                        });
                    },
                },
            },
            uploadArticles: {
                request: {
                    endpoint: '/branches/all/upload/articles',
                    method: 'POST',
                    body: ['data'],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(push('/branches'));
                        dispatch(globalActions.showMessage('Artikel wurden hochgeladen'));
                    },
                    failure: (dispatch, error, args) => {
                        dispatch(
                            globalActions.showMessage('Artikel konnten nicht hochgeladen werden.')
                        );
                    },
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        const response = normalize(payload.branches || {}, [branch]);

                        return state.mergeIn(['items'], response.entities.branches).merge({
                            isUploading: false,
                            uploadSuccessfull: true,
                            isFetching: false,
                        });
                    },
                    FAILED: (state, payload) => {
                        return state.merge({
                            errors: payload.errors,
                            isUploading: false,
                            uploadSuccessfull: false,
                            isFetching: false,
                        });
                    },
                },
            },
            addBranch: {
                request: {
                    endpoint: '/branches',
                    method: 'POST',
                    body: ['branch_id'],
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(push('/branches'));
                        dispatch(globalActions.showMessage('Die Filiale wurde erstellt'));
                    },
                    failure: (dispatch, error, args) => {
                        var msg = "";
                        if (args['branch_id'] === ""){
                            msg = "ungültige Nummer";
                        } else {
                            msg = "bereits vorhanden";
                        }
                        dispatch(
                            globalActions.showMessage("Filiale konnte nicht ertellt werden (" + msg + ").")
                        );
                    },
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        const response = normalize(payload.branch || {}, branch);
                        return state.mergeIn(['items'], response.entities.branches).merge({
                            isFetching: payload.isFetching,
                            finishedFetching: payload.finishedFetching,
                        });
                    },
                },
            },
            fetchBranches: {
                request: {
                    endpoint: '/branches',
                    method: 'GET',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {},
                    failure: (dispatch, error, args) => {
                        dispatch(
                            globalActions.showMessage('Filialen konnten nicht geladen werden.')
                        );
                    },
                },
                reducer: {
                    SUCCESS: (state, payload) => {
                        const response = normalize(payload.branches || [], [branch]);
                        return state.mergeIn(['items'], response.entities.branches).merge({
                            isFetching: payload.isFetching,
                            finishedFetching: payload.finishedFetching,
                        });
                    },
                },
            },
        },
        auth: {
            initialState: {
                isAuthenticated: false,
                access_token: null,
                uid: null,
                client: null,
                expiry: null,
                'token-type': 'Bearer',
            },
            logoutUser: {
                request: {
                    endpoint: '/auth/sign_out',
                    method: 'DELETE',
                },
                response: {
                    transform: [checkHttpStatus],
                    success: (dispatch, response, args) => {
                        dispatch(globalActions.showMessage('Erfolgreich abgemeldet.'));
                        localStorage.removeItem('scantouch_token');
                        dispatch(push('/login'));
                        disconnectFromWebsocket();
                    },
                    failure: (dispatch, error, args) => {
                        localStorage.removeItem('scantouch_token');
                        dispatch(push('/login'));
                    },
                },
            },
            resetPassword: {
                request: {
                    endpoint: '/users/password/reset',
                    body: ['email'],
                    method: 'POST',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(
                            globalActions.showMessage(
                                'Sie erhalten in Kürze eine E-Mail mit Anweisungen.'
                            )
                        );
                        dispatch(push('/login'));
                    },
                    failure: (dispatch, error, args) => {
                        dispatch(globalActions.showMessage('Zurücksetzen fehlgeschlagen'));
                    },
                },
            },
            updatePassword: {
                request: {
                    endpoint: '/users/password/update',
                    body: ['password', 'password_confirmation', 'reset_password_token'],
                    method: 'POST',
                },
                response: {
                    transform: [checkHttpStatus, parseJSON],
                    success: (dispatch, response, args) => {
                        dispatch(
                            globalActions.showMessage(
                                'Ihr neues Passwort wurde erfolgreich erstellt.'
                            )
                        );
                        dispatch(push('/login'));
                    },
                    failure: (dispatch, error, args) => {
                        dispatch(globalActions.showMessage('Zurücksetzen fehlgeschlagen'));
                    },
                },
            },
            loginUser: {
                request: {
                    endpoint: '/auth/sign_in',
                    body: ['email', 'password'],
                    method: 'POST',
                },
                response: {
                    transform: [checkHttpStatus, transformResponse],
                    success: (dispatch, response, args) => {
                        const headers = extractAuthenticationHeader(response);
                        const json = response.json;
                        headers.tenant_name = json.data.tenant_name;
                        connectToWebsocket(json.data.tenant_name);
                        localStorage.setItem('scantouch_token', JSON.stringify(headers));
                        dispatch(globalActions.showMessage('Anmeldung erfolgreich.'));
                        dispatch(endPoints.actions.user.currentUser());
                        dispatch(push('/receipts'));
                    },
                    failure: (dispatch, error, args) => {
                        dispatch(globalActions.showMessage('Anmeldung fehlgeschlagen'));
                    },
                },
            },
        },
    },
}));

const disconnectFromWebsocket = () => {
    removeSubscription(cable);
};

const removeSubscription = cable => {
    if (cable.subscriptions.subscriptions.length != 0) {
        const sub = cable.subscriptions.subscriptions[0];
        cable.subscriptions.remove(sub);
        removeSubscription(cable);
    }
};
// Debounce timer for the ReceiptsChannel live update. During a large stocktaking
// many receipts arrive in quick succession; we coalesce them into a single refetch
// instead of reloading the whole list once per receipt.
let receiptsRefetchTimer = null;

const refetchReceiptsDebounced = () => {
    if (receiptsRefetchTimer) {
        clearTimeout(receiptsRefetchTimer);
    }
    receiptsRefetchTimer = setTimeout(() => {
        receiptsRefetchTimer = null;
        const state = store.getState();
        const from = state.getIn(['receipts', 'from']);
        const to = state.getIn(['receipts', 'to']);
        store.dispatch(endPoints.actions.receipts.fetchReceipts({ from, to }));
    }, 1500);
};

const connectToWebsocket = tenant => {
    cable.subscriptions.create(
        {
            channel: 'ReceiptsChannel',
            tenant: tenant,
        },
        {
            received: function(data) {
                // A new receipt was created on the server. Refetch the list so it
                // appears in the dashboard without a manual reload. Debounced so a
                // burst of new receipts triggers only one reload.
                refetchReceiptsDebounced();
            },
            connected: function() {
                // On (re)connect we may have missed broadcasts while disconnected,
                // so pull the current state once to reconcile.
                console.log('connected');
                refetchReceiptsDebounced();
            },
            disconnected: function() {
                console.log('disconnected');
            },
            rejected: function() {
                console.log('rejected');
            },
        }
    );

    cable.subscriptions.create(
        {
            channel: 'ArticlesChannel',
            tenant: tenant,
        },
        {
            received: function(data) {
                console.log('ArticlesChannel ' + data);
                store.dispatch(endPoints.actions.branches.fetchBranches());
                if ('error' in data) {
                    store.dispatch(globalActions.showMessage('Fehler beim Artikel-Import!'));
                } else {
                    store.dispatch(globalActions.showMessage('Artikel-Import abgeschlossen!'));
                }
            },
            connected: function() {
                console.log('connected to articles channel');
            },
            disconnected: function() {
                console.log('disconnected');
            },
        }
    );

    cable.subscriptions.create(
        {
            channel: 'ExportChannel',
            tenant: tenant,
        },
        {
            received: function(data) {
                console.log('ExportChannel ' + data);
                let state = store.getState();
                let from = state.getIn(['receipts', 'from']);
                let to = state.getIn(['receipts', 'to']);
                console.log(`from: ${from} - to:${to}`);
                store.dispatch(endPoints.actions.receipts.fetchReceipts({ from, to }));
                store.dispatch(endPoints.actions.receipts.fetchReceipts());
            },
            connected: function() {
                console.log('connected');
            },
            disconnected: function() {
                console.log('disconnected');
            },
        }
    );
};

const reducerForKey = key => {
    if (key === 'receipts') {
        return reduceReducers(null, receiptsReducer, endPoints.reducers[key]);
    }
    if (key === 'branches') {
        return reduceReducers(null, branchesReducer, endPoints.reducers[key]);
    }
    if (key === 'subscriptions') {
        return reduceReducers(null, subscriptionsReducer, endPoints.reducers[key]);
    }
    if (key === 'payments') {
        return reduceReducers(null, paymentsReducer, endPoints.reducers[key]);
    }
    if (key === 'settings') {
        return reduceReducers(null, settingsReducer, endPoints.reducers[key]);
    }
    return endPoints.reducers[key];
};

for (var key in endPoints.reducers) {
    injectReducer(store, {
        key: key,
        reducer: reducerForKey(key),
    });
}

export default endPoints;
